import toast from "solid-toast";

export function usePopouts(sessionId?: string | null) {
  function openNamed(path: string, name: string) {
    if (!sessionId) {
      toast.error("No session ID.");
      return null;
    }
    const url = `/sessions/${sessionId}/${path}`;
    const w = window.open(url, name);
    if (!w) {
      toast.error("Pop-out blocked—allow pop-ups and try again.");
      return null;
    }
    try {
      w.focus();
    } catch {}
    return w;
  }

  function openCaseworker() {
    return openNamed("popout/caseworker", `sess-${sessionId}-caseworker`);
  }

  function openRespondent() {
    return openNamed("popout/respondent", `sess-${sessionId}-respondent`);
  }

  return { openCaseworker, openRespondent };
}
